import { useReservoirClient } from "@reservoir0x/reservoir-kit-ui";
import { setParams } from "@reservoir0x/reservoir-sdk";
import useInfiniteApi from "../../../hooks/useInfiniteApi";
export default function (options, swrOptions = {}, chainId) {
    var _a, _b;
    const client = useReservoirClient();
    const chain = chainId !== undefined
        ? client === null || client === void 0 ? void 0 : client.chains.find((chain) => chain.id === chainId)
        : client === null || client === void 0 ? void 0 : client.currentChain();
    const response = useInfiniteApi((_, previousPageData) => {
        if (!options || !options.id) {
            return null;
        }
        const url = new URL(`${chain === null || chain === void 0 ? void 0 : chain.baseApiUrl}/collections/daily-volumes/v1`);
        const query = { ...options };
        if (previousPageData && !previousPageData.continuation) {
            return null;
        }
        setParams(url, query);
        return [url.href, client === null || client === void 0 ? void 0 : client.apiKey, client === null || client === void 0 ? void 0 : client.version];
    }, {
        revalidateOnMount: true,
        revalidateFirstPage: false,
        ...swrOptions,
    });
    const activities = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.flatMap((page) => page.collections || [])) !== null && _b !== void 0 ? _b : [];
    return {
        ...response,
        data: activities,
    };
}
